import { render, staticRenderFns } from "./NumbersTab.vue?vue&type=template&id=2e5f0b50&scoped=true"
import script from "./NumbersTab.vue?vue&type=script&lang=js"
export * from "./NumbersTab.vue?vue&type=script&lang=js"
import style0 from "./NumbersTab.vue?vue&type=style&index=0&id=2e5f0b50&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2e5f0b50",
  null
  
)

export default component.exports